export function buildReplayPayload(data, metadata, stats, rawSegmentBytesCount) {
    const formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), `${metadata.session.id}-${metadata.start}`);
    const metadataAndSegmentSizes = {
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
        ...metadata,
    };
    const serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return {
        data: formData,
        bytesCount: data.byteLength,
        cssText: stats.cssText,
        isFullSnapshot: metadata.index_in_view === 0,
        rawSize: rawSegmentBytesCount,
        recordCount: metadata.records_count,
    };
}
//# sourceMappingURL=buildReplayPayload.js.map